function Home(props) {
  return <div className="container-fluid min-vh-100 bg-dark text-light d-flex flex-column align-items-center justify-content-center">
    <h1 className="text-center">Welcome to Basem's Movies Database!</h1>
    <p className="text-center">Use the navigation bar above to see all the recent movies, or to the favourites section where you can find your favourite movies</p>
  </div>;
}


export default Home;